module.exports = __webpack_public_path__ + "media/images/triangle--up-5151f1898d7078bfa7ec53061d39e3d5.png";